function getRegionCode() {
	const path = window.location.pathname;
	if (path.match('/regions/')) {
		const regex = /(regions)|([a-zA-Z]+)/g;
		try {
			return path.match(regex)[1];
		} catch (e) {
			console.warn(e);
		}
	}
	return null;
}

export default getRegionCode;
